import CalendarWraper from './CalendarWraper.vue';
import Index from './Index';
// import CalendarMeetingAdd from './CalendarMeetingAdd.vue';
import { frontendURL } from '../../../helper/URLHelper';
import UpcommingCalendars from './upcomming_calanders/UpcommingCalendars.vue';
import CalendarReports from './calendar_reports/CalendarReports.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/calendar'),
      name: 'calendars_state',  // must match with 'toStateName', name is only for 1st child
      roles: ['administrator', 'agent'],
      component: CalendarWraper,
      props: {
        headerTitle: 'Session',
        icon: 'people',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'calendar_meetings',
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'calendar_meeting_list',
          component: Index,
          roles: ['administrator'],
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/calendar'),
      roles: ['administrator', 'agent'],
      component: CalendarWraper,
      props: () => {
        return {
          headerTitle: 'Appointments Calendar',
          icon: 'video-call',
          showBackButton: false,
        };
      },
      children: [
        {
          path: 'appointments',
          name: 'upcomming_appointment_list', // must match this name in /sidebarItems/catalogues.js file in both "routes array" and "menuItems array"
          component: UpcommingCalendars,
          roles: ['administrator','agent'],
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/calendar'),
      roles: ['administrator', 'agent'],
      component: CalendarWraper,
      props: () => {
        return {
          headerTitle: 'Appointment Reports',
          icon: 'video-call',
          showBackButton: false,
        };
      },
      children: [
        {
          path: 'reports',
          name: 'calendar_reports', // must match this name in /sidebarItems/catalogues.js file in both "routes array" and "menuItems array"
          component: CalendarReports,
          roles: ['administrator','agent'],
        },
      ],
    },
  ],
};
